import { SearchParamKeys } from "@/types";
import { useEffect } from "react";
import { NavigateOptions, useSearchParams } from "react-router-dom";

type SearchParamsStateValue = string | undefined;
type SetSearchParamsStateValue = (nextValue: string, options?: NavigateOptions) => void;
type UseSearchParamsState = [SearchParamsStateValue, SetSearchParamsStateValue];

export const useSearchParamsState = <T extends string>(key: SearchParamKeys, value?: T): UseSearchParamsState => {
  const [searchParams, setSearchParams] = useSearchParams();

  const onSetSearchParams: SetSearchParamsStateValue = (nextValue, options?: NavigateOptions) => {
    searchParams.set(key, nextValue);
    setSearchParams(searchParams, options);
  };

  useEffect(() => {
    if (value && !searchParams.get(key)) onSetSearchParams(value, { replace: true });
  }, [value]);

  return [searchParams.get(key), onSetSearchParams];
};
